import { render, staticRenderFns } from "./UPreRegisterResend.vue?vue&type=template&id=1ffe9d08&scoped=true&"
import script from "./UPreRegisterResend.vue?vue&type=script&lang=ts&"
export * from "./UPreRegisterResend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe9d08",
  null
  
)

export default component.exports